import React from 'react';
import { GuessTheGender } from './pages/GuessTheGender';
import { Product } from './pages/Product';
import { ThankYou } from './pages/ThankYou';
import { Login } from './pages/Login';
import { Home } from './pages/Home';
import { Cart } from './pages/Cart';
import { Products } from './pages/Products';
import { Checkout } from './pages/Checkout';
import { PaymentMethods } from 'shared/build/enums';
import { CheckoutStripe } from './pages/CheckoutStripe';
import { Orders } from './pages/Orders';

export type ApplicationRoute = {
  path: string | string[];
  isProtected: boolean;
  showHeader: boolean;
  showFooter: boolean;
  component: () => React.ReactNode;
};

export const routes: ApplicationRoute[] = [
  {
    path: '/meus-presentes',
    isProtected: true,
    showHeader: true,
    showFooter: true,
    component: () => <Orders />,
  },
  {
    path: '/obrigado',
    isProtected: true,
    showHeader: true,
    showFooter: true,
    component: () => <ThankYou />,
  },
  {
    path: '/adivinhe-o-genero',
    isProtected: true,
    showHeader: false,
    showFooter: false,
    component: () => <GuessTheGender />,
  },
  {
    path: '/presentes/c/:categoryId',
    isProtected: true,
    showHeader: true,
    showFooter: true,
    component: () => <Products />,
  },
  {
    path: '/presentes/:id',
    isProtected: true,
    showHeader: true,
    showFooter: true,
    component: () => <Product />,
  },
  {
    path: '/presentes',
    isProtected: true,
    showHeader: true,
    showFooter: true,
    component: () => <Products />,
  },
  {
    path: '/inicio',
    isProtected: true,
    showHeader: true,
    showFooter: true,
    component: () => <Home />,
  },
  {
    path: '/carrinho',
    isProtected: true,
    showHeader: true,
    showFooter: true,
    component: () => <Cart />,
  },
  {
    path: `/checkout/${PaymentMethods.StripePT}`,
    isProtected: true,
    showHeader: true,
    showFooter: true,
    component: () => <CheckoutStripe paymentMethod={PaymentMethods.StripePT} />,
  },
  {
    path: `/checkout/${PaymentMethods.StripeBR}`,
    isProtected: true,
    showHeader: true,
    showFooter: true,
    component: () => <CheckoutStripe paymentMethod={PaymentMethods.StripeBR} />,
  },
  {
    path: '/checkout',
    isProtected: true,
    showHeader: true,
    showFooter: true,
    component: () => <Checkout />,
  },
  {
    path: '/',
    isProtected: false,
    showHeader: false,
    showFooter: false,
    component: () => <Login />,
  },
];
